import type { Logger, LogLevel } from "@infra-blocks/logger-interface";

export class ConsoleLogger implements Logger {
  #prefix: string;

  constructor(prefix: string) {
    this.#prefix = prefix;
  }

  log(level: LogLevel, message: string, ...args: unknown[]): void {
    switch (level) {
      case "trace":
        this.trace(message, ...args);
        break;
      case "debug":
        this.debug(message, ...args);
        break;
      case "info":
        this.info(message, ...args);
        break;
      case "warn":
        this.warn(message, ...args);
        break;
      case "error":
        this.error(message, ...args);
        break;
    }
  }

  trace(format: string, ...args: unknown[]): void {
    if (this.isTraceEnabled()) {
      console.trace(this.#prefixedFormat(format), ...args);
    }
  }

  debug(format: string, ...args: unknown[]): void {
    if (this.isDebugEnabled()) {
      console.debug(this.#prefixedFormat(format), ...args);
    }
  }

  info(format: string, ...args: unknown[]): void {
    if (this.isInfoEnabled()) {
      console.info(this.#prefixedFormat(format), ...args);
    }
  }

  warn(format: string, ...args: unknown[]): void {
    if (this.isWarnEnabled()) {
      console.warn(this.#prefixedFormat(format), ...args);
    }
  }

  error(format: string, ...args: unknown[]): void {
    if (this.isErrorEnabled()) {
      console.error(this.#prefixedFormat(format), ...args);
    }
  }

  isTraceEnabled(): boolean {
    return true;
  }

  isDebugEnabled(): boolean {
    return true;
  }

  isInfoEnabled(): boolean {
    return true;
  }

  isWarnEnabled(): boolean {
    return true;
  }

  isErrorEnabled(): boolean {
    return true;
  }

  #prefixedFormat(format: string) {
    return `${this.#prefix}${format}`;
  }

  // TODO: support for log level override.
  static create(options?: { prefix?: string }) {
    const { prefix = "" } = options ?? {};
    return new ConsoleLogger(prefix);
  }
}
